import styled from 'styled-components';

import AboutBannerSection from '_components/composed/sections/AboutBannerSection';
import AboutValuesSection from '_components/composed/sections/AboutValuesSection';
import AboutClientsSection from '_components/composed/sections/AboutClientsSection';
import SelectServiceSection from '_components/composed/sections/SelectServiceSection';
import TalkToExpertSection from '_components/composed/sections/TalkToExpertSection';

const StyledPageContainer = styled.div``;

const AboutPage = () => {
  return (
    <StyledPageContainer>
      <AboutBannerSection />
      <AboutValuesSection />
      <AboutClientsSection />
      <SelectServiceSection />
      <TalkToExpertSection />
    </StyledPageContainer>
  );
};

export default AboutPage;
